import React from 'react'
const ValidDownload = ({fileName, resourceTitle, downloadLimitUpdate, fileSize, 
        filePath,accessCode}) => {
    const onDownloadClick = (evt) => {
        downloadLimitUpdate(accessCode);
    }
    return (
        <div>
            <div className="downloaded-file-paths ">
                <div className="center-text downloaded-text mt-10">
                    <span>Resource:</span> <strong>{resourceTitle}</strong>
                </div>
                <div className="center-text downloaded-text">
                    <span>File Size:</span> <strong>{fileSize}</strong>
                </div>
            </div>
            <button type="button" onClick={onDownloadClick} className="mt-20">Download</button>
                
        </div>
    )
}

export default ValidDownload
